
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from "primeng/button";
import { TextareaModule } from 'primeng/textarea';
import { AudioToText } from './audio-to-text';
import { AutoResizeToMax } from './auto-resize-to-max';
import { ChatBubble } from './chat-bubble/chat-bubble';
import { ChatService } from './chat.service';
import { Table } from "./table/table";
import { VoiceBarsComponent } from "./voice-bars/voice-bars.component";
import { PasteTrackingService } from '../../paste-tracking.service';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [AutoResizeToMax, Button, ChatBubble, FormsModule, TextareaModule, VoiceBarsComponent, Table],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss'
})
export class ChatComponent {
  protected promptInput: string = '';
  protected cancelThinking: boolean = true;
  protected voiceInput: boolean = true;

  @ViewChild("chatInput") protected promptTextarea!: ElementRef<HTMLTextAreaElement>;

  constructor(public chatService: ChatService, public att: AudioToText, private pasteTracking: PasteTrackingService) {
    setTimeout(() => {
      const dialog = document.getElementById("dialog");
      if (!dialog) return;
      dialog.scroll({
        top: dialog.scrollHeight,
        behavior: "instant"
      });
    }, 100)
    this.att.textReceived.subscribe(txt => {
      this.promptInput += txt;
    });
  }


  async sendPrompt() {
    if (this.promptInput.trim() == "" || !this.chatService.userInputEnabled) return;
    const prompt = this.promptInput;
    this.promptInput = "";
    this.promptTextarea.nativeElement.style.height = "42px";
    await this.chatService.chat(prompt);
  }

  public toggleRecording() {
    if (this.att.isRecording.value) {
      this.att.stopRecording();
    } else {
      this.att.startRecording();
    }
  }

  public async onKeyDown(e: KeyboardEvent) {
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
      this.pasteTracking.trackKeystroke();
    }
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      await this.sendPrompt();
    }
  }

  public onPaste(e: ClipboardEvent) {
    this.pasteTracking.trackPaste(e, "chat");
  }
}